<template>
  <v-footer
    padless
    class="app-footer"
  >
    <v-container>
      <v-row
        justify="space-between"
        no-gutters
      >
        <v-col offset="1" offset-md="0" cols="7" md="5">
          <img
            class="prosper-mark mb-3"
            alt="Prosper Africa"
            src="@/assets/img/prosper-mark.svg"
          />
          <span class="copyright">
            ©{{ new Date().getFullYear() }} Prosper Africa
          </span>
          <span class="copyright">
            ©{{ new Date().getFullYear() }} Asoko Insight
          </span>
          <div class="footer-links mt-5 mb-5">
            <router-link to="terms"><span class="mr-6 footer-link">Terms and Conditions</span></router-link>
          </div>
        </v-col>
        <v-col cols="10" md="5">
          <p class="caption">
            This website was made possible through support provided by the Prosper Africa Executive Secretariat and the U.S. Agency for International Development, under the terms of Contract No. AID-OAA-C-17-00090.
          </p>
          <p class="caption">
            The content and information captured in the Virtual Deal Room is for informational purposes only, and nothing contained therein should be construed or implied to constitute consent, support or investment recommendations for any company or transaction, by the U.S. Government or its implementing partners.
          </p>
        </v-col>
        <v-col cols="2" md="1">
          <img
            alt="USAID logo. From the american people"
            src="@/assets/img/Vertical_RGB_294.png"
            height=100
            width=120
          />
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style lang="scss" scoped>
.app-footer {
  padding-top: 18px;
  padding-bottom: 18px;
  border-top: 1px solid rgba(147,151,157,0.2);
  border-color: rgba(147,151,157,0.2) !important;
}
.prosper-mark {
  height: 50px;
}
.copyright {
  display: block;
  font-size: 14px;
  color: #93979d;
}
.caption {
  color: #626262;
}
.footer-links {
  display: flex;
  flex-wrap: wrap;
}
.footer-link {
  font-size: 14px;
  white-space: nowrap;
}
</style>
